import { EPaginationActionTypes } from '../../actions/pagination';
import { EPromosActionTypes } from '../../actions/promos';
import { mapIsCompilation } from '../../mappers';
import { TIsCompilation } from '../../types/compilation';
import { TReduxActions } from '../../types/redux';

const defaultState: TIsCompilation = false;

export function isCompilationReducer(state: TIsCompilation = defaultState, action: TReduxActions) {
  if (action.type === EPromosActionTypes.Success || action.type === EPaginationActionTypes.Success) {
    return mapIsCompilation(action.payload);
  }

  return state;
}
